/**
 * @generated SignedSource<<9141535524b23a528cce2ac5040a13d8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WorkspaceSelector_workspaces$data = ReadonlyArray<{
  readonly id: string;
  readonly name: string;
  readonly parentId: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"WorkspaceSelectorContent_workspaces">;
  readonly " $fragmentType": "WorkspaceSelector_workspaces";
}>;
export type WorkspaceSelector_workspaces$key = ReadonlyArray<{
  readonly " $data"?: WorkspaceSelector_workspaces$data;
  readonly " $fragmentSpreads": FragmentRefs<"WorkspaceSelector_workspaces">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "WorkspaceSelector_workspaces",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "parentId",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "WorkspaceSelectorContent_workspaces"
    }
  ],
  "type": "Workspace",
  "abstractKey": null
};

(node as any).hash = "144cd7ab884140146e1719e22e3dffb1";

export default node;
